import { F0OneIconProps } from '@factorialco/f0-react'
import { ForwardRefExoticComponent } from 'react'

import {
  type ColumnConfigurations,
  type FormCustomTemplate,
  type TableColumnType,
  COLUMN_DEFINITIONS,
  TableColumnType as TableColumnTypeEnum,
} from './definitions'

export type CardProperty = {
  label: string
  icon?: ForwardRefExoticComponent<F0OneIconProps>
  render: (item: FormCustomTemplate) => {
    type: 'text' | 'dotTag' | 'status' | 'person'
    value: unknown
  }
}

export const createCardProperties = (
  columns: TableColumnType[],
  configurations?: ColumnConfigurations
): CardProperty[] =>
  columns
    .filter((col) => col !== TableColumnTypeEnum.Name && col in COLUMN_DEFINITIONS)
    .map((col) => {
      const def = COLUMN_DEFINITIONS[col]
      return {
        label: def.label(),
        icon: def.icon,
        render: def.render(configurations),
      }
    })
